module.exports = __webpack_public_path__ + "static/media/gensim_glove_vectors.b223d3d9.zip";